import global from '@remote/store/constantStore'
import { IRequestInterceptorParams } from '@remote/api/adapter/index.d'


export function addHeadersTarget ({ config, response }: { config: IRequestInterceptorParams; response: unknown }) {
  if (global.isXlBox && config.url.includes('api-hezi.xunlei.com')) {
    config.options['headers'] = Object.assign({}, config.options['headers'], { Target: global.fromSpace, 'X-Client-Type': 'pc'})
  }
  return { config, response }
}